// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { getMyAdminsInformation, MyAdminsInformationModel } from "@stoneage/App/Services/MyAdmins/MyAdminsService";

interface MyAdminsInformationApiParameter extends ApiParameter {}

type HandlerType = ApiHandler<
    MyAdminsInformationApiParameter & HasOnSuccess<MyAdminsInformationModel> & HasOnError,
    MyAdminsInformationModel
>;

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getMyAdminsInformation();
    } catch (e) {
        props.parameter.onError?.();
        return false;
    }
};

export const onSuccess: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameters, RequestDataFromApi, onSuccess];

const loadMyAdminsData = createHandlerChainRunner(chain, "LoadMyAdminsData");
export default loadMyAdminsData;
